module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('h1', {
    staticClass: "sgc-1",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "intro sgc-2"
  }, [_c('i', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")])]), _vm._v("n 1927, a would-be writer, Henry Miller, opened a speakeasy in Greenwich Village with his second wife June Mansfield. That year, he exhibited his first watercolours and, according to Miller, compiled notes for an entire cycle of autobiographical novels in one day. These "), _c('i', [_vm._v("Capricorn Notes")]), _vm._v(" became a resource and a wellspring which the writer drew on for the rest of his creative life. They became immediately useful in his second period in Paris, (1930–1939), when he published "), _c('i', [_vm._v("Tropic")]), _vm._v(" "), _c('i', [_vm._v("of")]), _vm._v(" "), _c('i', [_vm._v("Cancer")]), _vm._v(" (1934), "), _c('i', [_vm._v("Black Spring")]), _vm._v(" (1936) and "), _c('i', [_vm._v("Tropic")]), _vm._v(" "), _c('i', [_vm._v("of")]), _vm._v(" "), _c('i', [_vm._v("Capricorn")]), _vm._v(" (1939) and after that, with the publication of the "), _c('i', [_vm._v("Rosy")]), _vm._v(" "), _c('i', [_vm._v("Crucifixion")]), _vm._v(" trilogy of "), _c('i', [_vm._v("Sexus")]), _vm._v(" (1949), "), _c('i', [_vm._v("Plexus")]), _vm._v(" (1952), and "), _c('i', [_vm._v("Nexus")]), _vm._v(" (1960). This last was completed in April 1959 and published in France as "), _c('i', [_vm._v("Nexus I")]), _vm._v(" the following year. Miller’s imaginative commitment to the events recorded in the "), _c('i', [_vm._v("Notes")]), _vm._v(" lasted for most his life, with the writer revisiting the sequence and its unfolding again and again.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Nearly thirty years after its original publication, Grove Press published the first authorized US edition of "), _c('i', [_vm._v("Tropic")]), _vm._v(" "), _c('i', [_vm._v("of")]), _vm._v(" "), _c('i', [_vm._v("Cancer")]), _vm._v(" in 1961. That same year, Henry Miller, now a writer of international stature, was touring Europe and working on a new book, "), _c('i', [_vm._v("Nexus")]), _vm._v(" "), _c('i', [_vm._v("II")]), _vm._v(". He completed three drafts."), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#n1b1",
      "id": "b1n1"
    }
  }, [_vm._v("1")])])])]), _vm._v(" The release of "), _c('i', [_vm._v("Tropic")]), _vm._v(" "), _c('i', [_vm._v("of")]), _vm._v(" "), _c('i', [_vm._v("Cancer")]), _vm._v(" was keeping his publishers busy at the time, defending the author in obscenity trials in different states.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("The new manuscript, "), _c('i', [_vm._v("Nexus II,")]), _vm._v(" was a reworking of Miller’s first trip to Paris with June in 1928, a journey that had taken them deep into the Europe she saw as her homeland. Miller had already travelled over this territory in several works, notably in "), _c('i', [_vm._v("Tropic")]), _vm._v(" "), _c('i', [_vm._v("of")]), _vm._v(" "), _c('i', [_vm._v("Capricorn")]), _vm._v(", where he saw their journey as a metaphor for the sinuous, multi-faceted nature of his relationship with June. "), _c('i', [_vm._v("“When I look up from my machine, my eyes confront the large, many-coloured map of Europe which I have pinned to my wall; it is criss-crossed with rail and steam ship lines, with national frontiers, with indelible prejudices and rivalries. And the very raggedness of its contour … all this strain and erosion exemplifies, in my imagination, the conflict that has been going on between Hildred (June) and myself and of which this book is but a map.")]), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#n2b2",
      "id": "b2n2"
    }
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("With "), _c('i', [_vm._v("Tropic")]), _vm._v(" "), _c('i', [_vm._v("of")]), _vm._v(" "), _c('i', [_vm._v("Cancer")]), _vm._v(", "), _c('i', [_vm._v("Black")]), _vm._v(" "), _c('i', [_vm._v("Spring")]), _vm._v(" and "), _c('i', [_vm._v("Tropic")]), _vm._v(" "), _c('i', [_vm._v("of")]), _vm._v(" "), _c('i', [_vm._v("Capricorn")]), _vm._v(" using some of the material in their own incarnations, why we may ask should he have felt the need to revisit it again? What had been left unsaid?")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("One answer to these questions lies in the unpublished version of "), _c('i', [_vm._v("Tropic")]), _vm._v(" "), _c('i', [_vm._v("of")]), _vm._v(" "), _c('i', [_vm._v("Capricorn")]), _vm._v(", where Miller stated his commitment to a discursive, digressive style, the "), _c('i', [_vm._v("“vital part of me”")]), _vm._v(" made up by books and writers. "), _c('i', [_vm._v("“They too are in my blood”,")]), _vm._v(" he wrote, "), _c('i', [_vm._v("“carried along with my living, part of my hate and love”.")]), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#n3b3",
      "id": "b3n3"
    }
  }, [_vm._v("3")])])])]), _vm._v(" Here, he also described "), _c('i', [_vm._v("“elements creeping in which I am sure no editor would approve of. It is impossible for me to write even the most fantastic tale without mention of books and authors, without extraneous details, as it is called.”")])]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Miller was seventy years old in 1961, his memory reignited by this new exploration of Europe. Plainly, he felt it necessary to go over the map again for any new and "), _c('i', [_vm._v("“extraneous”")]), _vm._v(" details that might affect his understanding of himself as a writer; a status still under attack via the obscenity trials. "), _c('i', [_vm._v("Nexus II")]), _vm._v(" is also a travelogue of sorts, allowing him the chance to include extraneous descriptions and reflections that are not germane to the earlier books. To that extent, it is a re-examination, both of his precarious period as a would-be writer in Paris before the Crash of 1929 and his impressions of the Europe he found on his first visit, memories sharpened by his present situation.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('i', [_vm._v("“I’m a writer … a writer of no importance. I haven’t yet sold a story or an article to any editor. We live by our wits … do you know what that means? We’ve been hungry for days on end, we’ve robbed our friends, we’ve cheated the tradespeople, we’ve lived a dog’s life ever since I decided to be a writer.”")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#n4b4",
      "id": "b4n4"
    }
  }, [_vm._v("4")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("The years preceding this declaration/confession were critical years for Miller. He had fallen in love with June Mansfield in 1923, divorcing his first wife, Beatrice Wickens, in 1924 and leaving behind his 5-year-old daughter Barbara. He married June the same year, leaving work and responsibility behind with the intention of living as a writer. Their partnership was essential to Miller, not just at the personal and creative level but because it was only through June’s machinations that he was able to sell his work at all.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('i', [_vm._v("Nexus II")]), _vm._v(" opens in the summer of 1928 with Val and Mona (Henry and June) arriving in Paris on money provided by ‘Pop’, one of June’s many admirers. ‘Pop’ believed June was the author of Miller’s novel "), _c('i', [_vm._v("Moloch")]), _vm._v(", which had been written in installments and passed off to ‘Pop’ as hers. The couple spent more than a year in Europe on this visit, travelling to England, France, Belgium, Germany, Czechoslovakia, Austria, Hungary and Poland.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("June’s persona was self created. Her birth name was Smerdt, a Russian word for death, but her preferred name was June Mansfield, which she said was from "), _c('i', [_vm._v("“man’s field”")]), _vm._v(" or "), _c('i', [_vm._v("“cemetery”")]), _vm._v(". As Miller’s confidant, the photographer Brassai noted, she’d worked as "), _c('i', [_vm._v("“a B-girl at a gay nightclub for both sexes in Greenwich Village, and was courted by some of the butchest lesbians around”.")]), _vm._v(" Brassai recalled that June herself preferred "), _c('i', [_vm._v("“seraphic-looking women and, one evening fell madly in love with a young Russian woman whom Miller would call “Anastasia” … Henry wondered if they were planning to run away, for he knew they dreamed of Paris and of Montparnasse”.")]), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#n5b5",
      "id": "b5n5"
    }
  }, [_vm._v("5")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Miller described himself at the moment of his departure for Paris as "), _c('i', [_vm._v("“An expatriate from Brooklyn, a francophile, a vagabond, a writer at the beginning of his career, naive, enthusiastic, absorbent as a sponge, interested in everything and seemingly rudderless”.")]), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#n6b6",
      "id": "b6n6"
    }
  }, [_vm._v("6")])])])]), _vm._v(" This trip was to be his first foray into the dreams and yearnings he’d conjured in their life on the fringes of New York society in the 1920s. It was underpinned by the tantalizing uncertainty of his relationship with June, whose feints, ploys and subterfuges will be familiar to all readers of Miller. Foremost of these, in this period, concerned her relationship with "), _c('i', [_vm._v("“Anastasia”")]), _vm._v(" or "), _c('i', [_vm._v("“Stasia”,")]), _vm._v(" the character based on her lover, Jean Kronski. Jean had moved in with the couple in 1927 and her surprise departure for Europe with June some months later had left Miller enraged, bereaved and helpless. This abandonment prompted him that July to draft a grand sketch of his life and his obsession with June, now known as the "), _c('i', [_vm._v("Capricorn")]), _vm._v(" "), _c('i', [_vm._v("Notes")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("In due course, June cabled for Miller to join her but on this first trip he was heavily dependent on her, stumbling with the language, not knowing the territory, and captive of her dream of finding her own European background. "), _c('i', [_vm._v("“If I could only see the house in which she was born”,")]), _vm._v(" he wrote, "), _c('i', [_vm._v("“it seemed to me it would wipe out all the lies she had ever told me”.")]), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#n7b7",
      "id": "b7n7"
    }
  }, [_vm._v("7")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Their journey was interlinked with other expatriate Americans whom they encountered at the same bars and the same haunts, with Miller always doubting the accidental nature of these meetings. They longed to try the pleasures of "), _c('i', [_vm._v("Le Dôme, Les Deux Magots")]), _vm._v(" or "), _c('i', [_vm._v("Le Rat Mort,")]), _vm._v(" only to find them crowded with Americans; many responding to a best-selling 1927 travel guide "), _c('i', [_vm._v("Paris with the Lid Lifted,")]), _vm._v(" which June, at least, had read.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('i', [_vm._v("“The Notorious Café Du Dôme")]), _vm._v(" … "), _c('i', [_vm._v("You see all the Nuts and all the Freaks, plain and fancy; broke and affluent, mangy and modish, glassy-eyed and goo-goo eyed; Van Dyke")]), _vm._v(" [sic] "), _c('i', [_vm._v("bearded and pasty-faced; decorous and degenerate; pious and perverted; mademoiselleish young men and young-men-ish mademoiselles … Those who get themselves up the most grotesquely, are, 9 times out of 10, Americans.”")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#n8b8",
      "id": "b8n8"
    }
  }, [_vm._v("8")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Miller railed at these reminders of home, writing that: "), _c('i', [_vm._v("“Paris was getting on my nerves more and more. Perhaps not Paris itself but the people we seemed obliged to associate with. We were always running into the same types one meets in Greenwich Village.”")]), _vm._v(" The couple travelled more extensively but the drama of post-war Europe infested his consciousness. "), _c('i', [_vm._v("“That night I didn’t sleep a wink. It wasn’t the bedbugs that kept me awake, it was Europe, the horror and misery, which penetrated it through and through.”")]), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#n9b9",
      "id": "b9n9"
    }
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Notwithstanding this, the experience of Europe and in particular, the music of the alien, the ‘Gypsy’ and the ‘Jew’ awakened him to his task as a writer. "), _c('i', [_vm._v("“If I could write like those guys fiddle I’d be the happiest man alive ... First I’ve got to find out who I am, where I came from, where I’m going, why I’m here. I’ve got to make myself an orphan, teach myself my own language, stop taking music lessons and all that. First I’ve got to get rid of all the baggage I’ve accumulated … I mean literature. That Gypsy taught me more in a few minutes than all the volumes of Henry James, Dostoyevsky, Knut Hamsun and Peter Schlemihl combined.”")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#n10b10",
      "id": "b10n10"
    }
  }, [_vm._v("10")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("For Miller, the membrane of this cosmological world could also take him back to the alternate realm of his life in New York, the Greenwich Village speakeasy and the dance mania of his recent past: "), _c('i', [_vm._v("“One had to be screwy to patronize such a dive. A purgatorial hole through and through: a hole in the flap pocket of a demon whose punishment it was to masturbate himself to death … At home, and dancers themselves … sashay into Central Park.”")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#n11b11",
      "id": "b11n11"
    }
  }, [_vm._v("11")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("DH Lawrence’s "), _c('i', [_vm._v("Lady Chatterley’s Lover")]), _vm._v(" was published at the same time as Miller’s first visit to Europe and while he disputed Lawrence’s mystification of sex, he was entranced by the power of the writing, especially the opening passage which he would echo in the opening to "), _c('i', [_vm._v("Tropic of Cancer")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('i', [_vm._v("“Ours is essentially a tragic age, so we refuse to take it tragically. The cataclysm has happened, we are among the ruins, we start to build up new little habitats, to have new little hopes. It is rather hard work, there is now no smooth road into the future; but we go around, or scramble over the obstacles. We’ve got to live, no matter how many skies have fallen.”")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#n12b12",
      "id": "b12n12"
    }
  }, [_vm._v("12")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Miller made an intense study of Lawrence"), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#n13b13",
      "id": "b13n13"
    }
  }, [_vm._v("13")])])])]), _vm._v(" during his second period in Paris, completing it before June left him and filed for divorce in 1933. The spectre of obscenity hung over Lady "), _c('i', [_vm._v("Chatterley’s Lover")]), _vm._v(" until 1960, a fact that would have resonated with Miller when Grove chose to excise twenty-three manuscript pages from the authorized US edition of the original "), _c('i', [_vm._v("Nexus")]), _vm._v(" "), _c('i', [_vm._v("“due to its sexual content”.")]), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#n14b14",
      "id": "b14n14"
    }
  }, [_vm._v("14")])])])]), _vm._v(" One of the incidents described occurs after June had left for Europe with Jean, and Miller is on his own, prowling New York’s streets and parks.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('i', [_vm._v("“In the midst of these reflections I remember the Park again, two girls sitting on a knoll just above me”,")]), _vm._v(" he wrote. "), _c('i', [_vm._v("“One has her legs bent like a jack-knife, she’s fully exposed. Reclining on an elbow, I pretend to be studying a blade of grass … More and more the whole thing seemed like a dream. A delicious wet dream. I could well imagine what lay in store for me. But why me? What had I done to deserve this?")])]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("The meeting progresses to a "), _c('i', [_vm._v("bacchanal")]), _vm._v(" in the women’s apartment where the writer has cause for reflection.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro sgc-3"
  }, [_vm._v("“For an instant Mona flitted through my mind. If she could see me now! And she, what was she doing at this moment? Further speculation on that score was interrupted by Suzanne’s entrance. She had rigged herself up in a fetching negligee. As she fixed herself a drink she looked at me, as if approvingly and said: ‘You’re married, aren’t you?’”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro sgc-3"
  }, [_vm._v("“Amy smiled indulgently. ‘Suzanne is truly lecherous’, she said, licking her words. “I don’t think any man can satisfy her. When she’s really hot, why … well, I’ve seen her take a …” She turned and pointed to a long, thin black candle standing on the chest of drawers.”")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Any repeat of this adventure is stopped in its tracks by a cablegram from June arriving back from Paris – "), _c('i', [_vm._v("“Meet Me”.")])]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Apart from the ‘obscene’ content of their work, Miller shared with Lawrence a life-transforming partnership with a woman that led him towards a literature of personal redemption. Reviled in their own countries, both writers insisted on freedom of expression; the freedom to talk openly and frankly according to their vision. This freedom was being tested in the courts throughout Miller’s early and mid career as a writer.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('i', [_vm._v("Nexus II")]), _vm._v(" charts the first journey again, following the travelers until, after a year of high living, June gives their last $20 to a gypsy violinist, leaving them flat broke and living on the kindness of a Negro shoeshine. The American Consulate won’t assist them and once again it’s ‘Pop’ who sends the funds that allow them to return to Paris for the summer of 1929. They find it crawling with Americans bent on a similar quest.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Fleeing they travel down the Rhine to Vienna and on towards Hungary where the poor and dispossessed still struggle with ‘their’ Europe. There the farce of his situation descends; an unpublished writer, dependent on his wife’s admirers as she peddles his words as hers. In Romania and later staying with relatives of June, their plight grinds his imagination to a halt. Miller ponders what they are "), _c('i', [_vm._v("“doing here in this God-awful hole.… I would wonder, and remember … just how we had got here …”.")])]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("This locks the circuit back to those moments alone in New York’s Central Park and the women who entice him back to their lair. "), _c('i', [_vm._v("Nexus II")]), _vm._v(" ends in the Balkans, with Miller and June counting down the months to the Great Crash of October 1929, which will catapult them back to the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('i', [_vm._v("Nexus II")]), _vm._v(" will be a delight for any Miller fan, opening up fresh vantage points on the earlier works. For new readers, in a less-repressive century, the novel will provide an introduction to one of the most picaresque writers of modern English.")]), _vm._v(" "), _c('p', {
    staticClass: "bigspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "intro sgc-3"
  }, [_vm._v("Tom Thompson")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Sydney, April 2012")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("Notes")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _vm._v(" "), _c('table', {
    staticClass: "tbl_notes"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sgc-4",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#b1n1",
      "id": "n1b1"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Nexus II")]), _vm._v(", noted as A23 in "), _c('i', [_vm._v("Henry Miller: A Personal Archive")]), _vm._v(" (Roger Jackson & William Ashley) "), _c('i', [_vm._v("(HM:APA)")]), _vm._v("; the variants being pages 1–87, a second draft carbon pages 1–112, and a typed fragment pages 87–115.")])])])]), _vm._v(" "), _c('table', {
    staticClass: "tbl_notes"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sgc-4",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#b2n2",
      "id": "n2b2"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Noted as A4 in "), _c('i', [_vm._v("HM:APA.")])])])])]), _vm._v(" "), _c('table', {
    staticClass: "tbl_notes"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sgc-4",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#b3n3",
      "id": "n3b3"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Unpublished draft of "), _c('i', [_vm._v("Tropic")]), _vm._v(" "), _c('i', [_vm._v("of")]), _vm._v(" "), _c('i', [_vm._v("Capricorn")]), _vm._v(", 1934, noted as A4 in "), _c('i', [_vm._v("HM:APA.")])])])])]), _vm._v(" "), _c('table', {
    staticClass: "tbl_notes"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sgc-4",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#b4n4",
      "id": "n4b4"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Paris")]), _vm._v(" "), _c('i', [_vm._v("1928")]), _vm._v(", page 77.")])])])]), _vm._v(" "), _c('table', {
    staticClass: "tbl_notes"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sgc-4",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#b5n5",
      "id": "n5b5"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Henry Miller: The Paris Years by Brassai")]), _vm._v(" (Arcade, 1995).")])])])]), _vm._v(" "), _c('table', {
    staticClass: "tbl_notes"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sgc-4",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#b6n6",
      "id": "n6b6"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Big Sur and the Oranges of Hieronymus Bosch")]), _vm._v(" by Henry Miller (New Directions, 1957) page 277.")])])])]), _vm._v(" "), _c('table', {
    staticClass: "tbl_notes"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sgc-4",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#b7n7",
      "id": "n7b7"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Paris")]), _vm._v(" "), _c('i', [_vm._v("1928")]), _vm._v(", page 128.")])])])]), _vm._v(" "), _c('table', {
    staticClass: "tbl_notes"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sgc-4",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#b8n8",
      "id": "n8b8"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Bruce Reynolds: "), _c('i', [_vm._v("Paris with the Lid Lifted")]), _vm._v(" (George Sully, NY 1927), page 204.")])])])]), _vm._v(" "), _c('table', {
    staticClass: "tbl_notes"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sgc-4",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#b9n9",
      "id": "n9b9"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Paris")]), _vm._v(" "), _c('i', [_vm._v("1928")]), _vm._v(", page 108.")])])])]), _vm._v(" "), _c('table', {
    staticClass: "tbl_notes"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sgc-4",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#b10n10",
      "id": "n10b10"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Paris")]), _vm._v(" "), _c('i', [_vm._v("1928")]), _vm._v(", page 121.")])])])]), _vm._v(" "), _c('table', {
    staticClass: "tbl_notes"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sgc-4",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#b11n11",
      "id": "n11b11"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Paris")]), _vm._v(" "), _c('i', [_vm._v("1928")]), _vm._v(", page 131.")])])])]), _vm._v(" "), _c('table', {
    staticClass: "tbl_notes"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sgc-4",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#b12n12",
      "id": "n12b12"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Lady")]), _vm._v(" "), _c('i', [_vm._v("Chatterley’s")]), _vm._v(" "), _c('i', [_vm._v("Lover")]), _vm._v(", Florence 1928, page 1.")])])])]), _vm._v(" "), _c('table', {
    staticClass: "tbl_notes"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sgc-4",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#b13n13",
      "id": "n13b13"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Henry Miller: "), _c('i', [_vm._v("Notes on Aaron’s Rod")]), _vm._v(" (Black Sparrow, 1980) and "), _c('i', [_vm._v("The World of Lawrence")]), _vm._v(" (Capra Press, 1980).")])])])]), _vm._v(" "), _c('table', {
    staticClass: "tbl_notes"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "sgc-4",
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/04_introduction#b14n14",
      "id": "n14b14"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("HM:APA")]), _vm._v(", noted as A22, being pages 258–281 from Miller’s original manuscript for "), _c('i', [_vm._v("Nexus I")]), _vm._v(", and placed here in Miller’s preferred sequence.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "bigspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "imgxiii.png",
      "src": "Images/imgxiii.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "image sgc-2"
  }, [_c('img', {
    attrs: {
      "alt": "imgxix.png",
      "src": "Images/imgxix.png"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a16abb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/04_introduction.vue
// module id = 69
// module chunks = 0